import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Skel from './views/Skel.vue';
import ElectricForm from './views/Electric/Form.vue';
import ElectricResults from './views/Electric/Results.vue';
import GazForm from './views/Gaz/Form.vue';
import GazResults from './views/Gaz/Results.vue';
import Noutati from './views/Noutati/Main.vue';
import NoutatiList from './views/Noutati/List.vue';
import Noutate from './views/Noutati/Noutate.vue';
import { tipuri } from '@/modules/noutati/index.js';
import Pagini from './views/Pagina/Main.vue';
import Pagina from './views/Pagina/Show.vue';

Vue.use(Router);

const tipuriOptions = tipuri.map(tip => tip.replace('\-', '\-')).join('|');

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      meta: { bc: null },
      component: Home,
      children: [
        {
          path: '/electric',
          component: ElectricForm,
          meta: { bc: 'electric'  },
          children: [
            {
              path: '',
              name: 'electric',
              component: Skel,
            },
            {
              path: 'results',
              name: 'electric.results',
              meta: { bc: null },
              component: ElectricResults,
            }
          ]
        },
        {
          path: '/gaz',
          component: GazForm,
          meta: { bc: 'gaz' },
          children: [
            {
              path: '',
              name: 'gaz',
              component: Skel,
            },
            {
              path: 'results',
              name: 'gaz.results',
              meta: { bc: null },
              component: GazResults
            }
          ]
        },
        {
          path: `/noutati/:tip(${tipuriOptions})`,
          component: Noutati,
          meta: {
            bc: 'noutati.list'
          },
          children: [
            {
              path: '',
              name: 'noutati.list',
              component: NoutatiList,
              props: true
            },
            {
              path: ':id',
              name: 'noutati.show',
              component: Noutate,
              meta: { bc: null },
              props: true
            }
          ]
        },
        {
          path: '/pagini',
          component: Pagini,
          children: [
            {
              path: ':slug',
              name: 'pagini.show',
              meta: { bc: null },
              component: Pagina,
              props: true
            }
          ]
        }
      ]
    }
  ]
});
